/**
 * BuriedVerse — REAL LOGO on the round-1 overlay design (2026-07-22).
 *
 * Round 1 (BuriedVerseOverlayDemo) is the design of record per Yash; the concept experiment
 * was dropped. This only swaps the placeholder wordmark for the two real logo candidates.
 *
 * Sizing/padding per Yash: 70px wide on the 1280x704 (720p) base, height auto, top:20 right:20 —
 * the Jyotirlinga-family convention, same as bible_decoder's locked spec and the ffmpeg
 * composite convention "overlay=W-w-20:20". Width is fixed and height follows the REAL aspect;
 * never force a square box.
 *
 *   concept1 : 4267x7500 RGBA  -> 70 x 123px   (bible_decoder's logo is 118px at 70px — same family)
 *   diorama  : 1254x1254 RGB, NO ALPHA, white bg -> white-knocked-out + bbox-cropped to
 *              983x1051 -> 70 x 75px. See buried_verse_diorama_ko.png.
 *              ⚠️ The knockout is mine, done by corner flood-fill so interior white survives.
 *              A proper transparent export from source is still better than my reconstruction.
 *
 * Gloss is sentence-capitalised here ("To be anxious…") — the fix Yash flagged.
 */
import { AbsoluteFill, Img, staticFile, useCurrentFrame, interpolate } from "remotion";
import { BvFactTag, BvHero } from "./BuriedVerseOverlayDemo";

// Jyotirlinga-family convention: fix WIDTH, let height follow the real aspect.
const LOGO_W = 70;

const BvLogo: React.FC<{ src: string }> = ({ src }) => {
  const frame = useCurrentFrame();
  const fadeIn = interpolate(frame, [0, 36], [0, 1], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });
  return (
    <Img
      src={staticFile(src)}
      style={{
        position: "absolute",
        top: 20,
        right: 20,
        width: LOGO_W,
        height: "auto",
        opacity: fadeIn * 0.85,
      }}
    />
  );
};

const LogoPlate: React.FC<{ logo: string }> = ({ logo }) => (
  <AbsoluteFill style={{ background: "#000" }}>
    <Img src={staticFile("bv_demo/p1_merimnao.jpg")} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
    <BvLogo src={logo} />
    <BvFactTag kicker="Citation" value="James 1:6" />
    <BvHero
      variant="word"
      kicker="The word"
      word="μεριμνάω"
      translit="merimnaō"
      gloss="To be anxious, to be weighed down by care."
    />
  </AbsoluteFill>
);

export const BV_Logo1_Concept1: React.FC = () => <LogoPlate logo="buried_verse_cocnept1.png" />;
export const BV_Logo2_Diorama: React.FC = () => <LogoPlate logo="buried_verse_diorama_ko.png" />;

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
